import { Check, Circle } from "@phosphor-icons/react";

export default function DeliveryTimeline({ steps }) {
  return (
    <div data-testid="delivery-timeline" className="space-y-0">
      {steps.map((s, i) => {
        const last = i === steps.length - 1;
        return (
          <div key={s.step} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div
                className={`flex h-7 w-7 items-center justify-center rounded-full border ${
                  s.reached
                    ? "bg-[#0A4F35] border-[#0A4F35] text-white"
                    : "bg-white border-slate-300 text-slate-300"
                }`}
              >
                {s.reached ? <Check size={15} weight="bold" /> : <Circle size={9} weight="fill" />}
              </div>
              {!last && <div className={`w-0.5 flex-1 min-h-[26px] ${s.reached ? "bg-[#0A4F35]" : "bg-slate-200"}`} />}
            </div>
            <div className={`pb-6 pt-0.5 ${s.reached ? "text-slate-900 font-semibold" : "text-slate-400"}`}>
              <span className="text-sm">{s.step}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
